import { TrackRequest, TrackRequestModel } from "./track.model";

const ACTION_SCOPE = '[Track]';

export class SetFilteredTracks {
    static readonly type = `${ACTION_SCOPE} Set Filtered Tracks`;
    constructor(public payload: string) {}
}
export class SetTrackSearch {
    static readonly type = `${ACTION_SCOPE} Set Search Query`;
    constructor(public query: string | object) {}
}

// Get all Tracks action
export class Tracks {
    static readonly type = `${ACTION_SCOPE} Get Tracks`
}

// Get single Track action
export class Track {
    static readonly type = `${ACTION_SCOPE} Get Track`
    constructor(public payload: string) { }
}

// Add Create Track action
export class CreateTrack {
    static readonly type = `${ACTION_SCOPE} Create Track`;
    constructor(public payload: Omit<TrackRequest, 'id'>) { }
}

// Add Update Track action
export class UpdateTrack {
    static readonly type = `${ACTION_SCOPE} Update Track`;
    constructor(public payload: TrackRequest) { }
}

// Add Delete Track action
export class DeleteTrack {
    static readonly type = `${ACTION_SCOPE} Delete Track`;
    constructor(public payload: string) { }  // payload is the Track ID
}
